import { SelectionModel } from '@angular/cdk/collections';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  SaleConsignorModel,
  SaleConsignorTableFields,
} from 'src/app/models/sales/sale-consignor.model';
import { Helper } from 'src/app/utils/helper/helper';
import { AuthService } from '../../services/auth.service';
import { SaleConsignorContactsPopupComponent } from '../sale-consignor-contacts/sale-consignor-contacts-popup.component';
import { SaleConsignorListDataSource } from './sale-consignor-list-datasource';
@Component({
  selector: 'app-sale-consignor-list',
  templateUrl: './sale-consignor-list.component.html',
  styleUrls: ['./sale-consignor-list.component.scss'],
  providers: [Helper],
})
export class SaleConsignorListComponent implements OnInit {
  @Input() public tab: string;
  @Input() public saleConsignors: SaleConsignorModel[] = null;
  @Input() set allSalesConsignors(consignors: SaleConsignorModel[]) {
    this.saleConsignors = this.helper.deepCopy(
      consignors
    );
    if (this.saleConsignors?.length > 0) {
      setTimeout(() => {
        this.dataSource = new SaleConsignorListDataSource(
          this.saleConsignors,
          this.consignorSort
        );
        this.searchDataSource(this._searchTerm);
        this.dataSource.data?.forEach(vet => {
          if (this.defaultSelected.some(sel => sel.consignorId === vet.consignorId)) {
            this.selection.select(vet);
          }
        });
      }, 100)

    }
  }
  @Input() public allSalesConsignorsCount = 0;
  @Input() public defaultSelected: any[] = [];
  @Input() public allCountries: any[] = [];
  @Input() set searchTerm(value: string) {
    this._searchTerm = value;
    this.searchDataSource(value);
  }
  @Input() public isLoaderSaleConsignors: boolean = true;
  @Output() public readonly onCheckedSaleConsignorsEvent = new EventEmitter();
  public isVet = this.authService.IsVet();
  @Output() public readonly onConsignorContactSaveEvent = new EventEmitter();
  private _searchTerm: string;
  public checkedAll = false;
  public checkboxConsignorIds: number[];
  selection = new SelectionModel<any>(true, []);

  public saleConsignorTableFields = SaleConsignorTableFields;
  public isSalesCompany = this.authService.IsSalesCompany();
  private readonly destroy$ = new Subject<void>();
  public dataSource: SaleConsignorListDataSource;
  public cols = this.isVet ? [
    'checkbox',
    'businessName',
    'consignorContact',
    'horsesInSale',
    'xrayCount',
    'scopeCount',
    'xrayReportCount',
  ] : [
    'checkbox',
    'businessName',
    'consignorContact',
    'horsesInSale',
    'xrayCount',
    'scopeCount',
    'xrayReportCount',
    'link',
  ];
  public displayedColumns$: any;
  public closeResult = '';

  @ViewChild(MatSort) consignorSort: MatSort;

  constructor(private readonly helper: Helper, private readonly authService: AuthService, private readonly modalService: NgbModal) { }


  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource?.data.filter(item => item.consignorContact).length;
    return numSelected === numRows;
  }

  masterToggle() {    
    if (this.isAllSelected()) {
      this.selection.clear()
    } else {
      this.dataSource.data.forEach((row) => {
        if (row.consignorContact) {
          this.selection.select(row)
        }
      });
    }
    this.onCheckedSaleConsignorsEvent.emit({
      formDataEmailConsignors: this.selection.selected,
    });
  }
  public onTableScroll(): void {
    this.dataSource.onScroll();
  }
  trackById(index: number, item: SaleConsignorModel): any {
    return item.consignorId;
  }
  onSingleChange($event: any,element:any) {
    if ($event) {
      this.selection.toggle(element)
      this.onCheckedSaleConsignorsEvent.emit({
        formDataEmailConsignors: this.selection.selected,
      });
    }
  }

  public ngOnInit(): void {
    if (this.isVet) {
      this.cols = this.cols.filter(x => x != 'checkbox');
    }
    this.displayedColumns$ =  new BehaviorSubject(this.cols);
  }

  private searchDataSource(searchTerm: string) {
    if (searchTerm == undefined || searchTerm == null) {
      return;
    }
    if (this.dataSource) {
      if (searchTerm === '') {
        this.dataSource?.clearFilter(); // Add a method to reset the data
      } else {
        this.dataSource.searchTable(searchTerm);
      }
    }
  }

  
  handleContactSave(): void {
    console.log('Contact saved. Reloading contact list...');
    //this.loadConsignorContacts(); // or whatever action you want
  }
  public openConsignorContactPopup(element: any): void {
    
    const modalRef = this.modalService.open(SaleConsignorContactsPopupComponent, {
      size: '75-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });    
    modalRef.componentInstance.data = { consignorId: element.consignorId, consignorName: element.businessName, link: this.appendShareLinkPrefix(element.consignorDownloadLink), countries:this.allCountries };
    modalRef.componentInstance.onSave.subscribe((data: any) => {
      this.onConsignorContactSaveEvent.emit();
      modalRef.close();
    });
  }
  

  public ngOnDestroy(): void {
    this.destroy$.complete();
  }

  public appendShareLinkPrefix(linkPostfix: string) {
    return `${window.location.origin}/${linkPostfix}`;
  }
}
